export interface User {
  id: number;
  organizationId: number;
  username: string;
  password: string;
  accessLevels: string;
  name?: string;
  email?: string;
  phone?: string;
  profilePicture?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface Property {
  rentCollectorDetails?;
  id?: number;
  name: string;
  address: string;
  organizationId: number;
  floor: number;
  customFloor?: string;
  cellar?: boolean;
  size?: number;
  tenants?: number; // deprecated: use tenantsCount
  tenantsCount?: number;
  subPropertiesWithActiveTenants?: number;
  purchaseConsideration?: boolean;
  stampDuty?: number;
  trustRegNumber?: string;
  assesseeNumber?: string;
  propertyCard?: string;
  acquisitionDocument?: string;
  typeOfAcquisition?: TypeOfAcquisition;
  rentHistory?: [];
  lastRenovation?: string;
  rentCollectorId?: number;
  landId?: number;
  land?: {
    id: number;
    surveyNumber?: string;

    registration?: {
      id: number;
      trustRegNumber?: string;
      category?: string;
    };
  };
  minutesOfMeeting?: string;
  PTR?: string;
  houseTaxBill?: string;
  nonAgriculturalCertificate?: string;
  constructionPermissions?: string;
  buildingPlanApprovals?: string;
  feePaymentReceipts?: string;
  environmentalClearance?: string;
  fireSafetyCertificate?: string;
  disputes?: string;
  photos?: string;
  totalJantri?: number;
  // Sub Property specific fields
  rentIncrementPercentage?: number;
  caseDocument?: string;
  caseNumber?: string;
  caseReminder?: string;
  disputeReminder?: string;
  disputeReminderMargin?: number;
  jantri?: string;
  jantriDate?: string;
  jantriDocument?: string;
  rentAmount?: number;
  rentIncrementDuration?: number;
  shopNumber?: string;
  taxPercentage?: number;
  taxReminder?: string;
  propertyId?: number;
  // Additional document fields
  commercialPropertiesList?: string;
  residentialPropertiesList?: string;
  agriculturalLandsOnRent?: string;
  tenantDisputeList?: string;
  litigationCopies?: string;
  rentReceipts?: string;
  waterBills?: string;
  propertyTaxBills?: string;
  gasConnectionBills?: string;
  digitalRecordsOfBills?: string;
  listOfCases?: string;
  caseFiles?: string;
  interimFinalOrders?: string;
  judgmentCopies?: string;
  appealsFiled?: string;
  closedCases?: string;
  ongoingCases?: string;
  advocateDetails?: string;
  createdAt?: string;
  updatedAt?: string;
}

export enum BucketName {
  PHOTOS = 'mpm_property_photos',
  LOGO = 'organization_logo',
  PROPERTY_CARD = 'property_card',
  PTR = 'property_ptr',
  RENT_AGREEMENT = 'property_rent_agreement',
  HOUSE_TAX_BILL = 'house_tax_bill',
  PROPERTY_ACQUISITION = 'property_acquisition_document',
  PROFILE_PICTURE = 'mpm_profile_picture',
  MISAL_SHAREEF = 'misaal_shareef',
  DIRECTIVES_AL_VAZARAT_US_SAIFIYAH = 'directives_al_vazarat_us_saifiyah',
  MAZAR_PROPERTY_MAP = 'mazar_property_map',
}

export enum TypeOfAcquisition {
  PURCHASE = 'Purchase',
  GIFT_DEED = 'Gift Deed',
  RAJASHAHI = 'Rajashahi Document',
}

export enum PurchaseConsiderationStatus {
  UNDER_CONSIDERATION = 'Under consideration',
  NOT_CONSIDERING = 'Not considering',
}

export enum AccessLevels {
  SUPER_ADMIN = 'Super Admin',
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  RENT_COLLECTOR = 'Rent Collector',
}

export enum RegistrationBoards {
  WAQF = 'Waqf',
  TRUST = 'Trust',
  UNREGISTERED = 'Un-Registered',
}
